import { Button } from "@mui/material";
import { Link } from "@tanstack/react-router";
import { TFunction } from "i18next";
import { ProductRow } from "../../routes/products/route.tsx";
import { TableColumn } from "../GenericTable";

export function getProductColumns(t: TFunction): TableColumn<ProductRow>[] {
  return [
    {
      label: t("product.columns.productCode"),
      key: "productCode",
      render: (value) => (
        <Button 
          variant="text" 
          component={Link} 
          to={`/products/${value}`}
          sx={{ 
            py: 0, 
            minHeight: 'auto',
            textTransform: 'none',
          }}
        >
          {value}
        </Button>
      ),
    },
    { label: t("product.columns.productName"), key: "productName" },
    { label: t("product.columns.productGroupCode"), key: "productGroupCode" },
    { label: t("product.columns.gewascode"), key: "gewascode" },
    { label: t("product.columns.ingangsdatum"), key: "ingangsdatum" },
    { label: t("product.columns.vbnVersionDate"), key: "vbnChangeDateTime" },
    {
      label: t("product.columns.hasprimarycharacteristic"),
      key: "hasprimarycharacteristic",
      render: (value) =>
        value
          ? t("product.columns.vervallen_yes")
          : t("product.columns.vervallen_no"),
    },
    {
      label: t("product.columns.vervallen"),
      key: "vervallen",
      render: (value) =>
        value
          ? t("product.columns.vervallen_yes")
          : t("product.columns.vervallen_no"),
    },
  ];
}
